/**
 * Filters hierarchical data by grouping levels, promoting children when parents don't match
 * @param {Array} rows - The rows to filter
 * @param {Array} originalRows - The original unfiltered rows (for reference)
 * @param {Array} groupingLevels - The grouping levels to include
 * @param {Function} getSubRows - Function to get sub-rows from a row
 * @param {Array} parentChain - Chain of parent rows (for tracking ancestry)
 * @returns {Array} Filtered rows
 */
export const filterByGrouping = (rows, originalRows, groupingLevels, getSubRows, parentChain = []) => {
  if (!Array.isArray(rows)) return rows

  const result = []

  rows.forEach((row, index) => {
    const originalRow = originalRows?.[index] || row
    const newParentChain = [...parentChain, originalRow]
    const childRows = getSubRows(row)
    const originalChildRows = getSubRows(originalRow)
    const filteredChildren = filterByGrouping(childRows, originalChildRows, groupingLevels, getSubRows, newParentChain)

    if (groupingLevels.includes(row.grouping)) {
      result.push({
        ...row,
        data: filteredChildren,
        __originalData: originalRow,
        __parentChain: parentChain
      })
    } else if (filteredChildren && filteredChildren.length > 0) {
      result.push(...filteredChildren)
    }
  })

  return result
}
